export var Size = /*#__PURE__*/ function(Size) {
    Size["s"] = "s";
    Size["m"] = "m";
    return Size;
}({});
export var Placement = /*#__PURE__*/ function(Placement) {
    Placement["left"] = "left";
    Placement["right"] = "right";
    return Placement;
}({});
